import React from 'react';
import DashboardLayout from '../Layout/DashboardLayout';
import './Admin.css';

const AdminAdmins = () => {
    const admins = [
        { id: 1, name: 'Main Admin', email: 'admin@messagepe.com', role: 'Super Admin', status: 'Active', lastLogin: '2026-03-04 09:00' },
        { id: 2, name: 'Support lead', email: 'support@messagepe.com', role: 'Support Admin', status: 'Active', lastLogin: '2026-03-04 10:30' },
        { id: 3, name: 'Finance Mgr', email: 'finance@messagepe.com', role: 'Finance Admin', status: 'Inactive', lastLogin: '2026-03-01 15:45' }
    ];

    return (
        <DashboardLayout isAdmin={true}>
            <div className="admin-page">
                <header className="admin-header">
                    <h1>Admin Management</h1>
                    <button className="btn btn--primary">Add New Admin</button>
                </header>

                <div className="admin-section">
                    <h2>Administrative Users</h2>
                    <div className="admin-table-container">
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Role</th>
                                    <th>Status</th>
                                    <th>Last Login</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {admins.map(admin => (
                                    <tr key={admin.id}>
                                        <td>{admin.name}</td>
                                        <td>{admin.email}</td>
                                        <td><span className="badge badge-info">{admin.role}</span></td>
                                        <td>
                                            <span className={`status ${admin.status === 'Active' ? 'status--success' : 'status--error'}`}>
                                                {admin.status}
                                            </span>
                                        </td>
                                        <td>{admin.lastLogin}</td>
                                        <td>
                                            <div className="d-flex gap-2">
                                                <button className="btn btn--sm btn--outline">Edit</button>
                                                <button className="btn btn--sm btn--outline text-danger">Revoke</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="admin-section">
                    <h2>Role Permissions Matrix</h2>
                    <div className="admin-table-container">
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>Permission</th>
                                    <th>Super Admin</th>
                                    <th>Support Admin</th>
                                    <th>Finance Admin</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>User Management</td>
                                    <td>✅</td>
                                    <td>✅</td>
                                    <td>❌</td>
                                </tr>
                                <tr>
                                    <td>System Settings</td>
                                    <td>✅</td>
                                    <td>❌</td>
                                    <td>❌</td>
                                </tr>
                                <tr>
                                    <td>Wallet Management</td>
                                    <td>✅</td>
                                    <td>❌</td>
                                    <td>✅</td>
                                </tr>
                                <tr>
                                    <td>Reports Access</td>
                                    <td>✅</td>
                                    <td>✅</td>
                                    <td>✅</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default AdminAdmins;
